import NextLink from 'next/link';

import { OwnerAvatar } from '@playbooks/components/owner/owner-avatar';
import { Badge } from '@playbooks/ui/components/badge';

import { formatDate } from 'utils';

const BlogHero = ({ article }) => {
	// Render
	return (
		<header>
			<div className='flex-start gap-2 text-sm text-foreground-nav'>
				<NextLink
					href={`/${article.tag?.uuid}`}
					className='transition-colors hover:text-foreground focus-visible:rounded-control focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus/50'>
					{article.tag?.name}
				</NextLink>
				<span aria-hidden>•</span>
				<time>{formatDate(article.publishDate, 'MMM D, YYYY')}</time>
			</div>
			<h1 className='type-display mt-5 text-balance'>{article.title}</h1>
			{article.description && (
				<p className='mt-6 max-w-2xl text-lg leading-8 font-normal text-foreground-body'>{article.description}</p>
			)}
			<div className='mt-8 flex-start gap-3'>
				<OwnerAvatar layout='meta' owner={article.owner} />
				{article.status !== 'active' && (
					<>
						<span className='text-foreground-body'>•</span>
						<Badge variant={article.status}>{article.status}</Badge>
					</>
				)}
			</div>
		</header>
	);
};

export { BlogHero };
